var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"50vh"}},[_c('h1',{staticClass:"text-center mt-15 pt-15"},[_vm._v("This is not the page you are looking for")])])}]

export { render, staticRenderFns }